function isNokiaEmail(email: string): boolean {
    return Boolean(email?.match(/^[a-z]+[\w.\d]+@nokia\.com$/));
}

export { isNokiaEmail };
